import React from 'react';

// 单一 Context：state + setState 都通过 value 传递
const CommContext = React.createContext(null);

export default CommContext;
